import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { commercialConstants } from '../../../../common/commercial-constants';
@Component({
    selector: 'is-business-auto',
    templateUrl: './business-auto.component.html',
    styleUrls: ['./business-auto.component.scss'],
    standalone: false
})
export class BusinessAutoComponent implements OnInit, OnChanges {
    @Input() fnolForm: UntypedFormGroup;
    @Input() incidentLocationState: string;
    airBagsDeployedAnswer: UntypedFormControl = new UntypedFormControl('', Validators.required);
    authoritiesNotifiedAnswer: UntypedFormControl = new UntypedFormControl('', Validators.required);
    carSeatAnswer: UntypedFormControl = new UntypedFormControl('');
    carSeatDamageAnswer: UntypedFormControl = new UntypedFormControl('');
    carSeatUseAnswer: UntypedFormControl = new UntypedFormControl('');
    commercialAutoForm: UntypedFormGroup;
    insuredDriver: UntypedFormControl = new UntypedFormControl('', [Validators.required,
    Validators.pattern(commercialConstants.regexValidators.nameField)]);
    numberOfPassengers: UntypedFormControl = new UntypedFormControl('', [Validators.required,
    Validators.pattern(/^\d{1,2}$/)]);
    primaryCause: UntypedFormControl = new UntypedFormControl('', Validators.required);
    primaryCauses: string[] = ['Accident With Other Vehicle(s)', 'Ran Off Road', 'Collision With Bicycle',
        'Collision With Fixed Object', 'Collision With Pedestrian', 'Contact With Animal', 'Contact With Shopping Cart',
        'Collision All Other', 'Damaged Loading/Unloading', 'Injured in Proximity to Vehicle', 'Object Hit Vehicle',
        'Comprehensive All Other', 'Glass Breakage Only', 'Tow/Lockout/Key replacement', 'Partial Theft', 'Theft',
        'Vandalism', 'Flood Damage', 'Hail Damage', 'Weather All Other', 'Earth Movement', 'Fire'];
    rateState: string;
    toolTipVars = {
        vehicleVINTooltipActive1: false,
        vehicleVINHelptext1: false,
        primaryCauseTooltipActive1: false,
        primaryCauseHelptext1: false
    };
    vehicleDrivableAnswer: UntypedFormControl = new UntypedFormControl('', Validators.required);
    vehicleMake: UntypedFormControl = new UntypedFormControl('', Validators.required);
    vehicleModel: UntypedFormControl = new UntypedFormControl('', Validators.required);
    vehicleVIN: UntypedFormControl = new UntypedFormControl('');
    vehicleYear: UntypedFormControl = new UntypedFormControl('', [Validators.required,
    Validators.pattern(/^(19|20)\d\d$/)]);

    constructor(private formBuilder: UntypedFormBuilder) { }

    buildForm(): void {
        // Need to add new regex validations for claims fields
        this.fnolForm.addControl('commercialAuto', this.commercialAutoForm = this.formBuilder.group({
            vehicleYear: this.vehicleYear,
            vehicleMake: this.vehicleMake,
            vehicleModel: this.vehicleModel,
            vehicleVIN: this.vehicleVIN,
            primaryCause: this.primaryCause,
            insuredDriver: this.insuredDriver,
            vehicleDrivableAnswer: this.vehicleDrivableAnswer,
            airBagsDeployedAnswer: this.airBagsDeployedAnswer,
            carSeatAnswer: this.carSeatAnswer,
            carSeatUseAnswer: this.carSeatUseAnswer,
            carSeatDamageAnswer: this.carSeatDamageAnswer,
            numberOfPassengers: this.numberOfPassengers,
            authoritiesNotifiedAnswer: this.authoritiesNotifiedAnswer
        }));
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['incidentLocationState']) {
            this.updateCarSeatValidators();
        }
    }

    ngOnInit(): void {
        this.buildForm();
        this.updateCarSeatValidators();
        this.rateState = sessionStorage.getItem('state');
    }

    showCAQuestions(): boolean {
        return this.rateState === 'CA' && this.incidentLocationState !== 'CO' ||
            this.incidentLocationState === 'CA' && this.rateState !== 'CO';
    }

    showCOQuestions(): boolean {
        return this.rateState === 'CO' || this.incidentLocationState === 'CO';
    }

    updateCarSeatValidators(): void {
        if (this.showCAQuestions() || this.showCOQuestions()) {
            this.carSeatAnswer.setValidators(Validators.required);
            if (this.showCAQuestions() && this.carSeatAnswer.value === 'Yes') {
                this.carSeatUseAnswer.setValidators(Validators.required);
                this.carSeatDamageAnswer.setValidators(Validators.required);
            } else {
                this.carSeatUseAnswer.clearValidators();
                this.carSeatDamageAnswer.clearValidators();
                this.carSeatUseAnswer.setValue('');
                this.carSeatDamageAnswer.setValue('');
            }
        } else {
            this.carSeatAnswer.clearValidators();
            this.carSeatUseAnswer.clearValidators();
            this.carSeatDamageAnswer.clearValidators();
            // Clear values when not shown
            this.carSeatAnswer.setValue('');
            this.carSeatUseAnswer.setValue('');
            this.carSeatDamageAnswer.setValue('');
        }

        this.carSeatAnswer.updateValueAndValidity();
        this.carSeatUseAnswer.updateValueAndValidity();
        this.carSeatDamageAnswer.updateValueAndValidity();
    }
}
